import styled, { css, keyframes, DefaultTheme } from 'styled-components';

const pulse = ({ theme }: { theme: DefaultTheme }) => keyframes`
     0% {
         transform: scale(1);
     }

     50% {
         transform: scale(1.1);
         border: 0.125rem solid ${theme.colors.tertiary.hex};
     }

     100% {
         transform: scale(1);
         border: 0.125rem solid ${theme.colors.primaryContrast.hex};         
     }
 `;

export const CardContainer = styled.div`
    ${({ theme }) => css`
        position: relative;
        padding: 0.75rem 0.5rem;
        width: 17.875rem;
        height: 5.875rem;
        background-color: ${theme.colors.secondary.tints[0].hex};
        border-radius: 0.5rem 0.5rem 0 0;
        transition: transform 0.3s ease-in-out, height 0.3s ease-in-out;
        transform-origin: bottom;

        &:hover {
            height: 6.5rem;
            transform: translateY(-0.25rem);
        }
    `}
`;

export const Container = styled.div`
    display: flex;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 0.5rem;
    overflow: hidden;
`;

export const DegreeType = styled.span`
    ${({ theme }) => css`
        font-size: 1rem;
        margin-bottom: 0.25rem;
        line-height: 1.1;
        font-weight: 200;
        color: ${theme.colors.secondary.tints[8].hex};
    `}
`;

export const Course = styled.p`
    font-size: 1rem;
    line-height: 1.1;
    margin: 0;
    height: 2.4rem;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: height 0.4s ease;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

export const Button = styled.button<{ $clicked: boolean }>`
    ${({ theme, $clicked }) => css`
        border-radius: 0.4rem;
        width: 1.25rem;
        height: 1.25rem;
        background-color: ${theme.colors.primaryContrast.hex};
        border: 0.1rem solid ${theme.colors.secondary.tints[1].hex};
        position: absolute;
        top: 0.2rem;
        right: 0.2rem;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: transform 0.2s ease border 0.2s ease;

        ${$clicked &&
        css`
            animation: ${pulse} 0.3s ease;
        `}

        svg {
            width: 0.6rem;
            height: 0.6rem;
            stroke-width: 0.1rem;
        }
    `}
`;
